import i18next, { t } from 'i18next'
import { translationsLoaded } from './translations/crowdinTranslations'
import { closeOnOutsideClick } from './utils'
import { cloudPeriods, dedicPeriods, periods } from './constants'
import { shoppingBag } from './icons'
import { createDoubleButton } from './components/createDoubleButton'

function reducer(state, data) {
  if (data) {
    state = Object.assign(state, data)
  }

  return state
}

export function createStore(initialState) {
  let state = initialState
  let listeners = []
  const getState = () => ({ ...state })

  const setState = data => {
    state = reducer(state, data)
    listeners.forEach(listener => listener())
  }

  const subscribe = listener => {
    listeners.push(listener)

    /* unsubscription function */
    // return () => {
    //   listeners = listeners.filter(l => l !== listener)
    // }
  }

  const getTariffSettingOptns = (tariffName, parametrName) => {
    return state[tariffName]?.addons?.find(addon => addon?.addon_name === parametrName)?.item
  }

  return { getState, setState, subscribe, getTariffSettingOptns }
}

export function generateTariffLink(tarrifData) {
  let cartUrl = `${process.env.BILLING_URL_FRONTEND}cart?service=${tarrifData.service_category}&id=${tarrifData.service_id}&referrer=${window.location.pathname}`
  if (tarrifData.period) {
    cartUrl += `&period=${tarrifData.period.period}`
  }
  if (tarrifData['CPU count']) {
    cartUrl += `&${tarrifData['CPU count'].addon_name}=${tarrifData['CPU count'].item_id}`
  }
  if (tarrifData['Disk space']) {
    cartUrl += `&${tarrifData['Disk space'].addon_name}=${tarrifData['Disk space'].item_id}`
  }
  if (tarrifData['Memory']) {
    cartUrl += `&${tarrifData['Memory'].addon_name}=${tarrifData['Memory'].item_id}`
  }
  if (tarrifData['Port speed']?.addon_name) {
    cartUrl += `&${tarrifData['Port speed'].addon_name}=${tarrifData['Port speed'].item_id}`
  }

  return cartUrl
}

export function renderCardsErrorBlock({ text, icon } = {}) {
  const renderFn = () => {
    const allBuyBtns = document.querySelectorAll('[data-buy-btn]')

    allBuyBtns.forEach(btn => {
      const parent = btn.parentElement

      if (parent) {
        const newElement = document.createElement('div')
        newElement.innerHTML = createDoubleButton({
          href: process.env.BILLING_URL_FRONTEND,
          mainText: t(text) || t('vhost_card_buy_now_btn'),
          icon: icon || shoppingBag,
        })

        parent.replaceWith(newElement.firstElementChild)
      }
    })
  }

  if (translationsLoaded) {
    renderFn()
  } else {
    i18next.on('loaded', renderFn)
  }
}

export function renderPeriodsDropdown(periods, withPercents, percentsReversed, isDedic) {
  let listData = ''

  const percentsReversedClass = percentsReversed ? 'reversed' : ''

  periods?.forEach(el => {
    listData =
      listData +
      `<button
            class="tariff__period-option"
            type="button"
            data-period=${el.value}
            data-period-option
          >
          <span>${el.period} ${t(el.period_title.full)}</span>
            ${
              withPercents
                ? el.percent?.length > 0
                  ? `<span class="upper_xs tariff__option-percent ${percentsReversedClass}">${
                      isDedic ? el.percent : `-${el.percent}%`
                    }</span>`
                  : `<span class="tariff__option-percent blank ${percentsReversedClass}"></span>`
                : ''
            }
          </button>`
  })

  return listData
}

export function openPeriodList(selectEl, store) {
  let tariff = selectEl?.getAttribute('data-tariff-name')

  const optnsContainer = selectEl.parentElement.querySelector(
    `[data-period-options-container][data-tariff-name="${tariff}"]`,
  )

  const shevronIcon = selectEl.querySelector('.select__icon-arrowdown')

  optnsContainer.style.display = optnsContainer.style.display === 'flex' ? 'none' : 'flex'
  shevronIcon.classList.toggle('opened')

  const listenersToBeCleaned = [[document, documentClickHandler]]

  function documentClickHandler(e) {
    closeOnOutsideClick(e, optnsContainer, selectEl, shevronIcon, listenersToBeCleaned)
  }

  document.addEventListener('click', documentClickHandler)

  optnsContainer.addEventListener('click', e => onPeriodOptionClick(e, store))
}

function onPeriodOptionClick(e, store) {
  const state = store.getState()
  const tariffName = e?.currentTarget?.getAttribute('data-tariff-name')
  let id = e?.target?.getAttribute('data-period')
  let period = {}

  if (state[tariffName].service_category === 'dedic') {
    period = { ...dedicPeriods.find(i => i?.value === +id) }
  } else if (state[tariffName].service_category === 'cloud') {
    period = { ...cloudPeriods.find(i => i?.value === +id) }
  } else {
    period = { ...periods.find(i => i?.value === +id) }
  }

  const isPeriodEmpty = Object.keys(period).length === 0

  if (!state[tariffName].hasPeriodDiscounts) {
    period.percent = ''
  }

  state[tariffName] = {
    ...state[tariffName],
    period: isPeriodEmpty ? state[tariffName].period : period,
  }

  store.setState(state)
}

export function getTariffSetting(tariff, setting) {
  return tariff?.addons?.find(addon => addon?.addon_name === setting)?.item?.[0]
}

export function getTariffSpecificSetting(incomingTariff, setting, currentTariff) {
  return incomingTariff?.addons
    ?.find(addon => addon?.addon_name === setting)
    ?.item?.find(e => e?.item_count === currentTariff?.[setting]?.item_count)
}

export function getAddonNumber(tariff, setting) {
  return tariff?.addons?.find(addon => addon?.addon_name === setting)?.name_in_billmanager
}

export function renderMarkup(container, htmlElement) {
  container.innerHTML = ''

  container.appendChild(htmlElement)
}

export function openDropdown(event, store) {
  const selectEl = event.currentTarget
  const settingName = selectEl.getAttribute('data-setting')
  const optnsContainer = selectEl.nextElementSibling
  const shevronIcon = selectEl.querySelector('.select__icon-arrowdown')

  optnsContainer.style.display = optnsContainer.style.display === 'flex' ? 'none' : 'flex'
  shevronIcon.classList.toggle('opened')

  const listenersToBeCleaned = [[document, documentClickHandler]]

  function documentClickHandler(e) {
    closeOnOutsideClick(e, optnsContainer, selectEl, shevronIcon, listenersToBeCleaned)
  }
  document.addEventListener('click', documentClickHandler)

  optnsContainer.addEventListener('click', e => onOptionClick(e, settingName, store))
}

function onOptionClick(e, settingName, store) {
  let id = e?.target?.getAttribute('data-item-id')
  if (id) {
    const state = store.getState()
    const tariffName = e?.currentTarget?.getAttribute('data-tariff-name')
    const tarrifCard = state[tariffName]

    const parametrData = tarrifCard?.addons?.find(addon => addon?.addon_name === settingName)
    const addonName = parametrData?.name_in_billmanager

    const settingData = parametrData?.item?.find(i => i?.item_id === id)

    state[tariffName][settingName] = { ...settingData, addon_name: addonName }

    store.setState(state)
  }
}

export function cutAddonsDisplayValue(tariffsList) {
  tariffsList.forEach(tariff => {
    /**
     * It is needed just to remove dots and
     * different letter cases in tariffs parameters.
     * There is only Micro tariff on VM5 all other tariffs on VM6
     */
    tariff.addons.forEach(addon => {
      addon.item.forEach(el => {
        if (!isNaN(parseFloat(el.item_count))) el.item_count = parseFloat(el.item_count)
      })
    })
  })

  return tariffsList
}

export function getCurrentPeriodTitle(tariff) {
  return tariff?.period?.period_title?.full
}
